export default "__VITE_ASSET__d7a43061__"